import {
    // BulkUpdateButton,
    // BulkDeleteButton,
    BulkExportButton,
    BulkActionsToolbarProps,
} from 'react-admin';
import CopyIcon from '@material-ui/icons/AcUnit';

const getTableText = (data: Array<any>, divider: string, header = true) => {
    const columns = Object.keys(data[0]);
    const th = `${columns.join(divider)}`;
    const td = data
        .map((item) => Object.values(item).join(`"${divider}"`))
        .join('"\n"');
    return header ? `${th}\n"${td}"` : `"${td}"`;
};

const clipboardExporter = (data: any) => {
    const dataForExport = data
    // data.map(d => {
    //     const { backlinks, author, ...postForExport } = d; // omit backlinks and author
    //     postForExport.author_name = d.author.name; // add a field
    //     return postForExport;
    // });
    if (!navigator.clipboard) {
        return;
    }
    const text = getTableText(dataForExport, "\t", false);

    navigator.clipboard.writeText(text).then(() => {
        console.log("Copied to clipboard");
    });
};

export const BulkCopyClipboard = (props: any) =>
    <BulkExportButton
        exporter={clipboardExporter}
        label='pos.copy_clipboard'
        icon={<CopyIcon />}
        {...props}
    />

const BulkActionButtons = (props: BulkActionsToolbarProps) => {

    return <>
        <BulkCopyClipboard />
        <BulkExportButton />
        {/* <BulkDeleteButton /> */}
        {/* <BulkUpdateButton
            {...props}
            label="Reset Views"
            data={views}
            icon={<VisibilityOff />}
        /> */}
    </>
}

export default BulkActionButtons;